<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ organization.name }} - {{ $t("COMMON.SUBSCRIPTIONS") }}
      </span>
    </div>

    <subscription-list-table :filterOrganization="organization.id" />
  </div>
</template>

<script>
import SubscriptionListTable from "@/views/Pages/ResellerModule/SubscriptionManagement/partials/SubscriptionListTable.vue";

export default {
  name: "organization-view-subscriptions",

  components: { SubscriptionListTable },

  props: ["organization"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    organization(organization) {},
  },
};
</script>
